import { useEffect, useRef } from "react";
import Board from "../../chessBoard/components/Board";
import { Chess } from "@chesshotel/chesslib";
import { convertMoves } from "../../util/moves";
import { useState } from "react";
import { ChessSets } from "@chesshotel/constants";
import { useSettings } from "@/redux/settings";
import BlogBoardFrame from "./BlogBoardFrame";

export default function FreeTurnBoard(props) {
  const size = props.size || 504;
  const userSettings = useSettings();
  const settings = { ...userSettings, chessSet: ChessSets.STAUNTY };
  const [playingWhite, setPlayingWhite] = useState(false);
  const [possibleMoves, setPossibleMoves] = useState({});
  const [fen, setFen] = useState(props.fen || null);

  const chess = useRef(Chess()).current;

  useEffect(() => {
    const valid = props.fen && chess.load(props.fen, 1);

    if (!valid) {
      return;
    }
    setPlayingWhite(chess.turn() === "w");

    const possibleMoves = convertMoves(chess.moves({ verbose: true }));

    setPossibleMoves(possibleMoves);

    setFen(props.fen);
  }, [props.fen]);

  function moveMade(move) {
    const piece = chess.remove(move.from);
    chess.put(piece, move.to);

    const possibleMoves = convertMoves(chess.moves({ verbose: true }));
    setPossibleMoves(possibleMoves);
    setFen(fen);
  }

  return (
    <BlogBoardFrame title={props.title} caption={props.caption}>
      <div className="flex justify-start w-full md:w-fit">
        <Board
          settings={settings}
          fen={fen}
          animate={false}
          size={size}
          playingWhite={playingWhite}
          possibleMoves={possibleMoves}
          onMoveMade={(move) => moveMade(move)}
          edgeColor={props.edgeColor}
          flushTop={Boolean(props.title)}
        />
      </div>
    </BlogBoardFrame>
  );
}
